<template>
    <div class="entity-confirm-action">
        <div class="entity-confirm-action__title">
            <slot></slot>
        </div>

        <div class="entity">
            <div class="entity__title">{{ model.name }}</div>

            <div class="entity__list">
                <div class="entity__list-item">
                    <div class="entity__list-label">Марка:</div>
                    <div class="entity__list-value">{{ brandName || '-' }}</div>
                </div>

                <div class="entity__list-item">
                    <div class="entity__list-label">Коды моделей:</div>
                    <div class="entity__list-value">{{ modelCodeNames.join(', ') || '-' }}</div>
                </div>

                <div class="entity__list-item">
                    <div class="entity__list-label">Активность:</div>
                    <div class="entity__list-value">{{ getModelStatusLabel(model.status) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { getModelStatusLabel, ModelsPaginatorItem } from '@/types/model.type.ts';
    import { ModelCode } from '@/types/model-code/model-code.type.ts';

    const { model } = defineProps<{
        model: ModelsPaginatorItem,
    }>();

    const brandName = computed<string>(() => {
        switch (model.brand_id) {
            case 1: return 'Hyundai';
            case 2: return 'Genesis';
            default: return '-';
        }
    });

    const modelCodeNames = computed<string[]>(() => {
        return model.model_codes.map((modelCode: ModelCode) => modelCode.model_code);
    });
</script>
